import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

import Auth, { CognitoUser } from '@aws-amplify/auth';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';

import { BehaviorSubject, from, map, Observable } from 'rxjs';

import { DataUser } from '../models/userRoles..model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: CognitoUser | any;
  user$: BehaviorSubject<CognitoUser | any>;

  constructor(private http: HttpClient) {
    this.user = this.getUser();
    this.user$ = new BehaviorSubject<CognitoUser | any>(this.user);
  }

  getUser(): Observable<CognitoUser | any> {
    return this.user;
  }

  getUserAttributes(): CognitoUserAttribute[] | any {
    return this.user?.attributes;
  }

  setUser(user: CognitoUser | any): void {
    this.user = user;
    this.user$.next(user);
  }

  updateUserAttributes(user: CognitoUser | any, attributes: object): Observable<string> {
    return from(Auth.updateUserAttributes(user, attributes));
  }

  getCurrentAuthenticatedUser(): Observable<CognitoUser | any> {
    return from(Auth.currentAuthenticatedUser());
  }

  getUserRoles(): Observable<DataUser> {
    return this.http
      .get(environment.AURORA_API + '/GetUserById')
      .pipe(map((res: any) => res));
  }
}
